import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[capitalizeFirstLetter]'
})
export class CapitalizeFirstLetterDirective {

  constructor(private el: ElementRef, private control: NgControl) {}

  @HostListener('input', ['$event']) 
  onInput(event: any) {
    if (this.el.nativeElement.value) {
      const value = this.el.nativeElement.value;
      const transformed = this.capitalizeFirstLetter(value);
      
      if (value !== transformed) {
        this.control.control.setValue(transformed, { emitEvent: false });
      
        this.el.nativeElement.setSelectionRange(
          transformed.length, 
          transformed.length
        );
      }
    }
  }

  private capitalizeFirstLetter(value: string): string {
    if (!value) return '';
    
    // Convierte a minúsculas y luego pone en mayúscula la primera letra de cada palabra
    return value.toLowerCase().replace(/(?:^|\s)(\S)/g, function(match, group) {
      return match.replace(group, group.toUpperCase());
    });
  }
}
